<script lang="ts">
    import CreateWeightedScorePage from '@Criteria/WeightedScores/Pages/CreateWeightedScorePage'
    export default CreateWeightedScorePage
</script>

<template>
    <div>
        <CriterionSelectorDialog :viewModel="criterionSelectorDialog"
                                 @confirm-selection="handleSetCriterion" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div v-if="initialized" class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h6>
                        <a class="text-dark" @click="handleBack">
                            <i class="fa fa-angle-double-left" aria-hidden="true"></i> Back
                        </a>
                    </h6>
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Create weighted score</h1>
                </div>

                <div class="col-lg-6 text-right align-self-end">
                    <button type="submit" :class="hasChanges ? 'btn btn-warning' : 'btn btn-outline-secondary'" :disabled="isSaving" style="padding: 0.7em 2em;" form="create-weighted-score-form">
                        {{ saveButtonText }}
                    </button>
                </div>
            </div>

            <hr class="mb-5" />

            <form id="create-weighted-score-form" @submit.prevent="handleSave">
                <div class="form-group">
                    <label>Name: <span style="color: red;">*</span></label>
                    <input v-model.trim="name" type="text" class="form-control" required maxlength="100" minlength="2">
                    <div class="error">{{nameError}}</div>
                </div>

                <div class="form-group">
                    <label>Description:</label>
                    <textarea v-model.trim="description" class="form-control"></textarea>
                </div>

                <div class="form-group">
                    <label>Weights set:</label>
                    <select class="form-control" v-model="weightsSetId">
                        <option v-bind:value="null">Default</option>
                        <option v-for="ws in weightsSets" v-bind:value="ws.CriteriaWeightsSetId">
                            {{ ws.Name }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Criterion:</label>
                    <div class="input-group">
                        <input :value="criterionLabel" type="text" class="form-control pointer bg-white" readonly @click="handleShowCriterionSelector" />
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" @click="handleShowCriterionSelector">
                                <i class="fa-solid fa-ellipsis"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

